import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './ModalFormCatFechas.scss';
import { Form, Row, Col, Select, DatePicker, Button } from 'antd';
import InfoModal from 'components/InfoModal/InfoModal';
import { Modal, LoadingCard, Checkbox } from 'components';
import { DATE_FORMAT_FILTER_COLUMN } from 'utils/date';
import * as fieldMsgs from 'constants/formFieldsMessages';
import dayjs from 'dayjs';

import { PROCESOS_ELECTORALES, CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { getCatFechas, updateCatFechas } from 'actions/catFechas.actions';
import { ReactComponent as InfoCircle } from '../../../../../assets/images/InfoCircleExclamation/info_circle_exclamation.svg';

/**
 * Función que genera las semanas contenidas entre dos fechas
 * @param {Date} startDate Fecha de inicio de periodo
 * @param {Date} endDate Fecha de termino de periodo
 * @returns Arreglo de semanas de 7 días que exiten entre la fecha de inicio y fecha de fin
 */
const createWeeks = (startDate, endDate) => {
  const start = startDate.startOf('day');
  const end = endDate.startOf('day');

  const daysBetween = (new Date(end).getTime() - new Date(start).getTime()) / (1000 * 3600 * 24);
  const weeks = [];
  let counter = 0;
  let firstDayOfWeek;
  let lastDayOfWeek;

  for (let i = 0; i <= daysBetween; i += 1) {
    if (counter === i) {
      // Inicio de semana
      const temp = new Date(start);
      temp.setDate(new Date(start).getDate() + i);
      firstDayOfWeek = dayjs(temp).format('YYYYMMDDHHmmss');
    }
    if (counter + 6 === i) {
      // último día de la semana
      counter += 7;
      const temp = new Date(start);
      temp.setDate(new Date(start).getDate() + i);
      lastDayOfWeek = dayjs(temp).format('YYYYMMDDHHmmss');
      weeks.push({
        fechaInicio: firstDayOfWeek,
        fechaFin: lastDayOfWeek
      });
    } else if (daysBetween === i) {
      // Es el último día, se agrega el cacho de semana faltante
      const temp = new Date(start);
      temp.setDate(new Date(start).getDate() + i);
      lastDayOfWeek = dayjs(temp).format('YYYYMMDDHHmmss');
      weeks.push({
        fechaInicio: firstDayOfWeek,
        fechaFin: lastDayOfWeek
      });
    }
  }
  return weeks;
};

const ModalFormularioCatalogoFechas = ({ onClose, visible, initialData, periodosProceso }) => {
  const [formCatFecha] = Form.useForm();
  const dispatch = useDispatch();

  // Rango de fechas de inicio y fin seleccionado
  const [inicioPeriodo, setInicioPeriodo] = useState(null);
  const [finPeriodo, setFinPeriodo] = useState(null);
  const [rangeDateValues, setRangeDateValues] = useState([]);
  const [periodosProcElec, setPeriodosProcElec] = useState([]);

  // Fechas generadas por el rango elegido
  const [semanasRango, setSemanasRango] = useState([]);

  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [isVisibleEditSuccesModal, setIsVisibleEditSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const procesosCat = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const iniOperacion =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;
  const procesosElectorales = procesosCat.map((proceso) => ({
    ...proceso,
    nombreProcesoEspecifico: proceso?.nombreProcesoEspecifico?.replace('Ã±', 'ñ')
  }));
  // Proceso seleccionado para consultar sus datos
  const [procesoSeleccionado, setProcesoSeleccionado] = useState(null);

  const { RangePicker } = DatePicker;
  const [mostrarSemanas, setMostrarSemanas] = useState(null);
  const [weeksValidation, showWeeksValidation] = useState(null);
  const handleMostrarSemanas = (value) => {
    setMostrarSemanas(value);
  };

  /// Ocultar la información de semanas si se cierra el registro de fecha
  const handleCancel = () => {
    onClose?.();
    handleMostrarSemanas(false);
    showWeeksValidation(false);
    setPeriodosProcElec([]);
    setSemanasRango([]);
    setProcesoSeleccionado(null);
    formCatFecha.resetFields();
  };

  const weekContainsFechas = (fechaSemIni, fechaSemFin, fechaIni, fechaFin) => {
    const fSemIni = dayjs(fechaSemIni, 'YYYYMMDD');
    const fSemFin = dayjs(fechaSemFin, 'YYYYMMDD');
    const fIni = dayjs(fechaIni, 'YYYYMMDD');
    const fFin = dayjs(fechaFin, 'YYYYMMDD');

    return fSemIni <= fIni && fSemFin >= fFin;
  };

  const handleOK = async () => {
    setIsLoading(true);

    try {
      const values = await formCatFecha.validateFields();
      const haySeleccionados = semanasRango.some(
        (semana) => semana.seleccionado && semana.seleccionado > 0
      );
      if (!mostrarSemanas || !haySeleccionados) {
        showWeeksValidation(true);
        return;
      }
      showWeeksValidation(false);

      const fechasPeriodoCopy = JSON.parse(JSON.stringify(semanasRango)); // Array nuevo, NO REFERENCIA
      if (initialData) {
        // Se asignan id's a las fechas si es edición
        // fechasPeriodoCopy son todas las semanas entre el rango de fechas del periodo
        for (let idx = 0; idx < fechasPeriodoCopy.length; idx += 1) {
          for (let j = 0; j < initialData.fechas.length; j += 1) {
            if (
              weekContainsFechas(
                fechasPeriodoCopy[idx].fechaInicio.substring(0, 8),
                fechasPeriodoCopy[idx].fechaFin.substring(0, 8),
                initialData.fechas[j].fechaInicio,
                initialData.fechas[j].fechaFin
              )
            ) {
              fechasPeriodoCopy[idx].idPeriodo = initialData.fechas[j].idPeriodo;
              fechasPeriodoCopy[idx].idProcesoPeriodos = initialData.fechas[j].idProcesoPeriodos;

              if (!fechasPeriodoCopy[idx].seleccionado) {
                fechasPeriodoCopy[idx].estatus = 0; // Se cancelan semanas en edición, no seleccionadas
              }
              break;
            }
          }
        }

        // Buscar fechas de edición que no esten en los periodos creados
        const fechasEdiFaltantes = [];
        for (let j = 0; j < initialData.fechas.length; j += 1) {
          let encontrado = false;
          for (let i = 0; i < fechasPeriodoCopy.length; i += 1) {
            if (
              weekContainsFechas(
                fechasPeriodoCopy[i].fechaInicio.substring(0, 8),
                fechasPeriodoCopy[i].fechaFin.substring(0, 8),
                initialData.fechas[j].fechaInicio,
                initialData.fechas[j].fechaFin
              )
            ) {
              encontrado = true;
              break;
            }
          }
          if (!encontrado) {
            fechasEdiFaltantes.push(initialData.fechas[j]);
          }
        }

        if (fechasEdiFaltantes.length > 0) {
          // Hay fechas de edición que no se estan usando en el nuevo rango de fechas
          // Se les asigna el estatus 0 porque se cancelarán
          for (let index = 0; index < fechasEdiFaltantes.length; index += 1) {
            fechasEdiFaltantes[index].estatus = 0;
          }
          // Se agregan las fechas faltantes a la petición
          fechasPeriodoCopy.push(...fechasEdiFaltantes);
        }
      }

      const peticion = initialData
        ? {
            toUpdate: [
              {
                idProcesosPeriodo: initialData.idProcesosPeriodo,
                idProcesoElectoral: values.idProcesoElectoral,
                fechaInicio: dayjs(values.periodo[0]).format('YYYYMMDDHHmmss'),
                fechaFin: dayjs(values.periodo[1]).format('YYYYMMDDHHmmss'),
                fechas: fechasPeriodoCopy.filter((f) => f.seleccionado || f.estatus === 0)
              }
            ]
          }
        : {
            toSave: [
              {
                idProcesoElectoral: values.idProcesoElectoral,
                fechaInicio: dayjs(values.periodo[0]).format('YYYYMMDDHHmmss'),
                fechaFin: dayjs(values.periodo[1]).format('YYYYMMDDHHmmss'),
                fechas: fechasPeriodoCopy.filter((f) => f.seleccionado)
              }
            ]
          };

      const { success } = await dispatch(updateCatFechas(peticion));
      if (success) {
        onClose?.();
        formCatFecha.resetFields();
        setProcesoSeleccionado(null);
        handleMostrarSemanas(false);
        showWeeksValidation(false);
        if (initialData) {
          setIsVisibleEditSuccessModal(true);
        } else {
          setIsVisibleSuccessModal(true);
        }
      } else {
        onClose?.();
        formCatFecha.resetFields();
      }
    } catch (error) {
      console.log(error);
      return;
    } finally {
      setIsLoading(false);
    }
  };

  const handleGenerateDates = async () => {
    setIsLoading(true);
    try {
      await formCatFecha.validateFields();
      handleMostrarSemanas(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  dayjs.locale('es');
  const construirFechaFromString = (fecha) => {
    if (fecha !== '' && fecha) {
      return dayjs(fecha, 'YYYYMMDDHHmmss').format(DATE_FORMAT_FILTER_COLUMN);
    }
    return '';
  };
  const construirPeriodo = (inicio, fin) => {
    if (inicio && fin) {
      let resultDate;
      if (inicio.substring(0, 4) === fin.substring(0, 4)) {
        // El año es el mismo en ambas fechas
        const firstDate = construirFechaFromString(inicio);
        const secondDate = construirFechaFromString(fin);
        resultDate = `${firstDate.substring(0, firstDate.length - 8)} al ${secondDate}`;
      } else {
        // Los años son diferentes
        resultDate = `${construirFechaFromString(inicio)} al ${construirFechaFromString(fin)}`;
      }
      return resultDate;
    }
    return '';
  };

  // Revisa y filtra los checkbox para guardar la posición de aquellas semanas si seleccionadas
  const onCheckOrUncheck = (semanaIdx) => {
    semanasRango[semanaIdx].seleccionado = !semanasRango[semanaIdx].seleccionado;
    const semanasRangoCopy = JSON.parse(JSON.stringify(semanasRango)); // Array nuevo, NO REFERENCIA para que tome el cambio
    setSemanasRango(semanasRangoCopy);
  };

  const onChangeRange = (value) => {
    if (value != null && value.length === 2) {
      const primerFecha = value?.[0];
      const ultimaFecha = value?.[1];
      const startDate = primerFecha.format('YYYYMMDDHHmmss');
      const endDate = ultimaFecha.format('YYYYMMDDHHmmss');
      setInicioPeriodo(startDate);
      setFinPeriodo(endDate);
      const weeks = createWeeks(value?.[0], value?.[1]);
      for (let index = 0; index < weeks.length; index += 1) {
        // Se seleccionan todas las semanas por default
        weeks[index].seleccionado = true;
      }
      setSemanasRango(weeks);
    } else {
      setInicioPeriodo(null);
      setFinPeriodo(null);
      setSemanasRango([]);
      handleMostrarSemanas(false);
      showWeeksValidation(false);
    }
  };

  const validateDateRange = (_, value) => {
    if (value != null && value.length === 2) {
      const primerFecha = value[0];
      const ultimaFecha = value[1];
      const primerFechaStr = value[0].format('YYYYMMDDHHmmss');
      const ultimaFechaStr = value[1].format('YYYYMMDDHHmmss');

      if (initialData) {
        // No es posible disminuir el rango del periodo. Se debe tener una fecha base para generar las semanas, de lo contrario se pueden tener resultados
        // inesperados, ej. se selecciona sem de 1-7 esperando que contemple el 3 y al editar esa sem se divide en 2 y el monitoreo quede en una semana incorrecta
        // por lo que la fecha de inicio del periodo cuando ya se tiene fechas en uso, no se puede mover
        const hayAsignados = initialData.fechas.some(
          (semana) => semana.asignado && semana.asignado > 0
        );
        if (
          hayAsignados &&
          primerFecha < dayjs(initialData.fechaInicio, 'YYYYMMDDHHmmss').startOf('day')
        ) {
          return Promise.reject(Error('No se puede disminuir el periodo seleccionado.'));
        }
        // El rango debe contener aquellos periodos que ya esten en uso por algún monitoreo
        for (let i = 0; i < initialData.fechas.length; i += 1) {
          if (
            initialData.fechas[i].asignado &&
            !weekContainsFechas(
              primerFechaStr.substring(0, 8),
              ultimaFechaStr.substring(0, 8),
              initialData.fechas[i].fechaInicio.substring(0, 8),
              initialData.fechas[i].fechaFin.substring(0, 8)
            )
          ) {
            return Promise.reject(Error('No se puede quitar periodos en uso.'));
          }
        }
      }

      // Se valida que el rango de fechas seleccionado no contenga otro periodo
      for (let index = 0; index < periodosProcElec.length; index += 1) {
        if (
          primerFecha <
            dayjs(periodosProcElec[index].fechaInicio, 'YYYYMMDDHHmmss').startOf('day') &&
          ultimaFecha > dayjs(periodosProcElec[index].fechaFin, 'YYYYMMDDHHmmss').endOf('day')
        ) {
          return Promise.reject(
            Error('No es posible capturar el periodo, porque ya existe uno registrado.')
          );
        }
      }
    }
    return Promise.resolve();
  };

  const disabledDate = (current) => {
    // Cannot select days before start or end of electoral process
    if (current < rangeDateValues[0] || current > rangeDateValues[1]) {
      return true;
    }
    for (let index = 0; index < periodosProcElec.length; index += 1) {
      if (initialData) {
        // Si es edición, pueden seleccionar las fechas del mismo periodo a editar
        if (
          periodosProcElec[index].idProcesosPeriodo !== initialData.idProcesosPeriodo &&
          current >= dayjs(periodosProcElec[index].fechaInicio, 'YYYYMMDDHHmmss').startOf('day') &&
          current <= dayjs(periodosProcElec[index].fechaFin, 'YYYYMMDDHHmmss').endOf('day')
        ) {
          return true;
        }
      } else if (
        // si no, no se pueden seleccionar fechas de otro periodo registrado
        current >= dayjs(periodosProcElec[index].fechaInicio, 'YYYYMMDDHHmmss').startOf('day') &&
        current <= dayjs(periodosProcElec[index].fechaFin, 'YYYYMMDDHHmmss').endOf('day')
      ) {
        return true;
      }
    }
    return false;
  };

  const getPeriodosProceso = async (idProcesoElectoral) => {
    // Se consultan los periodos registrados en el proceso seleccionado
    // para validar que no se registren periodos duplicados o encimados
    let periodos = [];
    const { success, response } = await dispatch(
      getCatFechas(
        {
          idProcesoElectoral
        },
        false
      )
    );
    if (success && response?.data.code === 200) {
      const periodosBD = response.data.procesosElectorales[0];
      periodos = periodosBD.periodos;
    }
    return periodos;
  };

  const getRangoFechasMinMaxProceso = (proc) => {
    // Se establece la fecha mínima y máxima seleccionable en el calendario
    // se considera la fecha de operación
    let primerFecha = dayjs(proc.fechaInicio, 'YYYYMMDDHHmmss');
    let ultimaFecha = dayjs(proc.fechaFin, 'YYYYMMDDHHmmss');
    const confDate = dayjs(iniOperacion, 'YYYYMMDD');
    if (primerFecha < confDate) {
      primerFecha = confDate;
    }
    if (ultimaFecha < confDate) {
      ultimaFecha = confDate;
    }
    if (primerFecha > ultimaFecha) {
      primerFecha = ultimaFecha;
    }
    return [primerFecha, ultimaFecha];
  };

  useEffect(() => {
    if (initialData) {
      // Se establecen los valores default del formulario para edición
      const fechaInicial = dayjs(initialData.fechaInicio, 'YYYYMMDDHHmmss');
      const fechaFinal = dayjs(initialData.fechaFin, 'YYYYMMDDHHmmss');
      const formatedInitialData = {
        idProcesoElectoral: initialData.idProcesoElectoral,
        periodo: [fechaInicial, fechaFinal]
      };
      formCatFecha.setFieldsValue(formatedInitialData);
      const startDate = fechaInicial.format('YYYYMMDDHHmmss');
      const endDate = fechaFinal.format('YYYYMMDDHHmmss');
      setInicioPeriodo(startDate);
      setFinPeriodo(endDate);
      const proc = procesosCat.find((p) => {
        return p?.idProcesoElectoral === initialData.idProcesoElectoral;
      });
      setProcesoSeleccionado(proc);
      setPeriodosProcElec(periodosProceso); // Todos los periodos del proceso electoral
      setRangeDateValues(getRangoFechasMinMaxProceso(proc));
      const weeks = createWeeks(fechaInicial, fechaFinal);
      // Se dejan seleccionadas las semanas donde las fechas coincidan entre las semanas generadas y las que vienen para editar
      for (let idx = 0; idx < weeks.length; idx += 1) {
        for (let j = 0; j < initialData.fechas.length; j += 1) {
          if (
            weeks[idx].fechaInicio.substring(0, 8) ===
              initialData.fechas[j].fechaInicio.substring(0, 8) &&
            weeks[idx].fechaFin.substring(0, 8) === initialData.fechas[j].fechaFin.substring(0, 8)
          ) {
            weeks[idx].seleccionado = true;
            break;
          }
        }
      }
      setSemanasRango(weeks);
      showWeeksValidation(false);
      handleMostrarSemanas(true);
    }
  }, [initialData]); // Se ejecutará de nuevo si initialData cambia, que no es la idea

  const checkDisabledWeek = (fechaIni, fechaFin) => {
    if (initialData && initialData.fechas) {
      for (let i = 0; i < initialData.fechas.length; i += 1) {
        if (
          initialData.fechas[i].asignado &&
          initialData.fechas[i].asignado > 0 &&
          weekContainsFechas(
            fechaIni.substring(0, 8),
            fechaFin.substring(0, 8),
            initialData.fechas[i].fechaInicio.substring(0, 8),
            initialData.fechas[i].fechaFin.substring(0, 8)
          )
        ) {
          return 'disabled';
        }
      }
    }
    return '';
  };

  const checkDisableDates = () => {
    if (procesoSeleccionado == null) {
      return true;
    }
    if (initialData) {
      const hayAsignados = initialData.fechas.some(
        (semana) => semana.asignado && semana.asignado > 0
      );
      return hayAsignados ? [true, false] : false;
    }
    return false;
  };

  return (
    <>
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => {
          setIsVisibleSuccessModal(false);
        }}
        description="Periodo guardado exitosamente."
      />
      <InfoModal
        visible={isVisibleEditSuccesModal}
        onClose={() => {
          setIsVisibleEditSuccessModal(false);
        }}
        description="Periodo modificado exitosamente."
      />
      <Modal
        title={initialData ? 'Editar periodo' : 'Agregar periodo'}
        wrapClassName="modal-formulario-monitoreo"
        open={visible}
        width="90%"
        onCancel={() => {
          handleCancel();
        }}
        footer={null}>
        <div>
          <LoadingCard visible={isLoading} />
          <div className="modal-formulario-subtitulo">
            <span className="container-description-form">
              <InfoCircle style={{ marginLeft: '10px', marginRight: '10px' }} />
              <span className="modal-formulario-subtitulo-descripcion">
                Selecciona los datos solicitados para generar el periodo.
              </span>
              <span className="modal-formulario-subtitulo-requeridos">*Campos obligatorios.</span>
            </span>
          </div>
          <div>
            <Form layout="vertical" form={formCatFecha}>
              <Row gutter={24}>
                <Col xs={8}>
                  <span className="buscador-monitoreo-etiqueta"> </span>
                  <Form.Item
                    label="Proceso Electoral:"
                    required
                    name="idProcesoElectoral"
                    rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
                    <Select
                      options={procesosElectorales}
                      placeholder="Selecciona el Proceso Electoral"
                      fieldNames={{
                        value: 'idProcesoElectoral',
                        label: 'descripcion'
                      }}
                      onChange={async (value) => {
                        const proc = procesosCat.find((p) => {
                          return p?.idProcesoElectoral === value;
                        });
                        setProcesoSeleccionado(proc);
                        const periodos = await getPeriodosProceso(proc.idProcesoElectoral);
                        setPeriodosProcElec(periodos); // Todos los periodos del proceso electoral
                        setRangeDateValues(getRangoFechasMinMaxProceso(proc));
                      }}
                      disabled={initialData !== null}
                    />
                  </Form.Item>
                </Col>
                <Col xs={9}>
                  <span className="buscador-monitoreo-etiqueta"> </span>
                  <Form.Item
                    name="periodo"
                    label="Rango de fechas:"
                    rules={[
                      { required: true, message: fieldMsgs.ERR_RANGE_DATE_FIELD_REQUIRED },
                      { validator: validateDateRange }
                    ]}>
                    <RangePicker
                      // minDate={dayjs(procesoSeleccionado.fechaInicio, 'YYYYMMDDHHmmss')}
                      // maxDate={dayjs(procesoSeleccionado.fechaFin, 'YYYYMMDDHHmmss')}
                      disabled={checkDisableDates()}
                      // [true, false]
                      //   () => {
                      //     // if (procesoSeleccionado == null) {
                      //     //   return true;
                      //     // }
                      //     // if (initialData) {
                      //     const hayAsignados = initialData.fechas.some(
                      //       (semana) => semana.asignado && semana.asignado > 0
                      //     );
                      //     return hayAsignados ? [true, false] : [true, false];
                      //   }
                      //   return false;
                      // }
                      // }
                      // disabled={procesoSeleccionado == null}
                      disabledDate={disabledDate}
                      format={DATE_FORMAT_FILTER_COLUMN}
                      onChange={onChangeRange}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <span className="buscador-monitoreo-etiqueta"> </span>
                  <Button
                    text="Generar"
                    type="primary"
                    onClick={handleGenerateDates}
                    className="btn-center">
                    <span>Generar</span>
                  </Button>
                </Col>
              </Row>
              {mostrarSemanas ? (
                <div>
                  <Col>
                    <span className="modal-info-sub-desc-result">
                      {procesoSeleccionado.descripcion || procesoSeleccionado.procesoElectoral} del{' '}
                      {construirPeriodo(inicioPeriodo, finPeriodo)}.
                    </span>
                    <div className="modal-formulario-subtitulo">
                      <span className="container-description-form">
                        <InfoCircle style={{ marginLeft: '10px', marginRight: '10px' }} />
                        <span className="modal-formulario-subtitulo-descripcion">
                          Solo las fechas seleccionadas se agregarán al periodo.
                        </span>
                      </span>
                    </div>
                  </Col>
                  <div className="periodos-semanas">
                    <Col>
                      {weeksValidation && (
                        <div className="ant-form-item-explain-error custom-error-label">
                          Selecciona por lo menos una fecha.
                        </div>
                      )}
                      <ul>
                        {semanasRango.map((date, index) => (
                          <div className="semana" key={`${date.fechaInicio}-${date.fechaFin}`}>
                            <Checkbox
                              key={`${date.fechaInicio}-${date.fechaFin}`}
                              id={`semana-${index}`}
                              name="semana"
                              value={date}
                              disabled={checkDisabledWeek(date.fechaInicio, date.fechaFin)}
                              checked={semanasRango[index].seleccionado}
                              onChange={() => onCheckOrUncheck(index)}
                            />
                            <label htmlFor={`semana-${index}`} className="desc">
                              {construirPeriodo(date.fechaInicio, date.fechaFin).toUpperCase()}
                            </label>
                          </div>
                        ))}
                      </ul>
                    </Col>
                  </div>
                  <Col style={{ marginTop: '15px', textAlign: 'center', margin: 'auto' }}>
                    <Button text="Guardar" type="primary" onClick={handleOK}>
                      Guardar
                    </Button>
                  </Col>
                </div>
              ) : null}
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalFormularioCatalogoFechas;

ModalFormularioCatalogoFechas.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  initialData: PropTypes.shape({
    idProcesoElectoral: PropTypes.number,
    fechaInicio: PropTypes.string,
    fechaFin: PropTypes.string,
    idProcesosPeriodo: PropTypes.string,
    fechas: PropTypes.arrayOf(
      PropTypes.shape({
        fechaInicio: PropTypes.string,
        fechaFin: PropTypes.string,
        asignado: PropTypes.number,
        idPeriodo: PropTypes.number,
        idProcesoPeriodos: PropTypes.number
      })
    )
  }),
  periodosProceso: PropTypes.arrayOf(
    PropTypes.shape({
      // fechaInicio: PropTypes.string,
      // fechaFin: PropTypes.string,
      // asignado: PropTypes.number,
      // idPeriodo: PropTypes.number,
      // idProcesoPeriodos: PropTypes.number
    })
  )
};

ModalFormularioCatalogoFechas.defaultProps = {
  visible: true,
  initialData: null,
  periodosProceso: []
};
